import { getCategory, fetchCategoryList } from 'shared/models/api';
import { sanitizeCategory, parentCategories } from 'shared/models/category';
import { searchOptsFromQueryParams } from '../searchResults/helpers';
import { registerError } from 'components/errorPages/actions';

const SET_CATEGORY = 'SET_CATEGORY';
const LOAD_CATEGORY = 'LOAD_CATEGORY';
const LOAD_CATEGORY_PRODUCTS = 'LOAD_CATEGORY_PRODUCTS';
const UNLOAD_CATEGORY = 'UNLOAD_CATEGORY';

const init = {
  category: null,
  parentCategories: [],
  searchOpts: {},
  loadingCategory: false,
  loadingProducts: false,
  products: [],
  count: 0,
  facets: []
};

export default function(state = init, action = {}) {
  switch (action.type) {
    case SET_CATEGORY:
      return {
        ...state,
        loadingCategory: false,
        loadingProducts: false,
        category: action.category,
        parentCategories: action.parentCategories,
        searchOpts: action.searchOpts,
        products: action.products,
        count: action.count,
        facets: action.facets
      };
    case LOAD_CATEGORY:
      return {
        ...state,
        loadingCategory: true
      };
    case LOAD_CATEGORY_PRODUCTS:
      return {
        ...state,
        loadingProducts: true
      };
    case UNLOAD_CATEGORY:
      return {
        ...state,
        category: {},
        products: [],
        count: 0
      };
    default:
      return state;
  }
}

export function fetchCategory(urlName, queryParams) {
  return (dispatch, getState) => {
    const currentState = getState().category || {};

    if (currentState.loading) return Promise.resolve();

    if (currentState.category && currentState.category.url_name === urlName) {
      dispatch({ type: LOAD_CATEGORY_PRODUCTS });
    } else {
      dispatch({ type: LOAD_CATEGORY });
    }

    const searchOpts = searchOptsFromQueryParams(queryParams);

    return Promise.all([getCategory(urlName, searchOpts), fetchCategoryList()])
      .then(([{ category, products, count, facets }, categoryList]) => {
        category = sanitizeCategory(category);

        dispatch({
          type: SET_CATEGORY,
          category,
          parentCategories: parentCategories(category, categoryList),
          searchOpts,
          products,
          count,
          facets
        });

        return category;
      })
      .catch(err => dispatch(registerError(err)));
  };
}

export function clearCategory() {
  return dispatch => dispatch({ type: UNLOAD_CATEGORY });
}
